<template>
  <div class="w100 pt20 pl20 pr20 pb20 bg-w">
    <div class="w100 cl-f">
      <span class="font-16">评价管理</span>
      <div class="fr">
        关键字：
        <el-input class="mr10" style="width: 190px;" clearable v-model="keyWord" placeholder="输入关键字"></el-input>
        <el-button type="primary" @click="page = 1, fetchList()" :loading="loading">查询</el-button>
      </div>
    </div>

    <section class="w100 pt20" v-loading="loading">
      <el-table class="w100 tx-c my-table" :data="list" stripe border>
        <el-table-column align="center" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ ((page - 1) * size) + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="服务名称" prop="serveName"></el-table-column>
        <el-table-column align="center" label="评分时间" width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | filterDate('yyyy-MM-dd hh:mm') }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="办理时长评分" prop="scoreDuration" width="80"></el-table-column>
        <el-table-column align="center" label="服务质量评分" prop="scoreQuality" width="80"></el-table-column>
        <!-- <el-table-column align="center" label="评分内容" prop="comment"></el-table-column> -->
        <el-table-column align="center" label="学号/工号" prop="userId" width="120"></el-table-column>
        <el-table-column align="center" label="姓名" prop="userName" width="100"></el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <span class="ml10 mr10 blue cu-p" @click="showJudge(scope.row)">查看详情</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[5, 30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
    </section>

    <el-dialog :visible.sync="isShow" width="1000px" :close-on-click-modal="false">
      <span class="font-16" slot="title">{{ selData.serveName }}</span>
      <div class="w100">
        <div class="w100 flex-box">
          <div class="pr10">服务时长</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreDuration" disabled allow-half show-score :score-template="String(selData.scoreDuration * 2)"></el-rate>
          </div>
        </div>
        <div class="w100 pt10 flex-box">
          <div class="pr10">服务质量</div>
          <div class="flex-1">
            <el-rate v-model="selData.scoreQuality" disabled allow-half show-score :score-template="String(selData.scoreQuality * 2)"></el-rate>
          </div>
        </div>
        <el-input class="w100 mt20" type="textarea" :rows="5" placeholder="请输入内容" v-model="selData.comment" readonly></el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeCollect",
  props: [],
  data() {
    return {
      loading: false,

      siftData: [],
      serveId: "",
      keyWord: "",

      list: [],
      page: 1,
      size: 30,
      total: 0,

      isShow: false,
      selData: {
        serveName: "",
        scoreDuration: 0,
        scoreQuality: 0,
        comment: ""
      }
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  created() {},
  mounted() {
    this.serveId = this.$route.params.id;
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      this.$http
        .post(
          "serveComment/findPage",
          this.$qs.stringify({
            serveId: this.serveId,
            keyWord: this.keyWord,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data.RetData);
          if (data.RetStatus == 0 && data.RetCode) {
            this.list = data.RetData.list;
            this.total = data.RetData.total;
          } else {
            this.$message({
              message: data.RetMsg,
              type: "error"
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            message: "网络请求错误，请检查网络",
            type: "error"
          });
          this.loading = false;
        });
    },
    showJudge(obj) {
      this.selData.serveName = obj.serveName;
      this.selData.comment = obj.comment;
      this.selData.scoreDuration = obj.scoreDuration / 2;
      this.selData.scoreQuality = obj.scoreQuality / 2;

      this.$nextTick(() => {
        this.isShow = true;
      });
    },
    changeSize(value) {
      this.size = value;
      this.fetchList();
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    }
  },
  watch: {}
};
</script>

<style scoped>
</style>
